export const environment = {
  production: true,
  ministry:"ប្រព័ន្ធគ្រប់គ្រងឯកសារ",
  baseUrl: 'https://admin-api.kampongthom.gov.kh/',
  default_doc_type_id: '5be39bddb7eb68078652121f',
  default_from_to_id: '5f0fc6117ef0d6671abcd66b',
  scanner_key: '',
};
